qtee.customDesign = window.qtee.customDesign || {};

qtee.customDesign.SizeTextView = Backbone.Marionette.ItemView.extend({
	template: '/custom-design/templates/text-size',
	ui: {
		back: '.back',
		slider: '.slider',
		input: '.fontSizeInput'
	},
	events: {
		'click @ui.back': 'backClick',
		'keypress @ui.input': 'filterSize'
	},
	backClick: function (e) {
		console.log(e);
		this.filterSize(e, true);
		this.$events.triggerHandler('back.SizeTextView');
		this.backCallback && this.backCallback({ fontChangedTo: this.state.fontChangedTo });

	},
	filterSize: function (e, force) {

		var that = this;

		var submit = function () {

			that.fontSizeChange();
			$(that.ui.slider).slider('value', parseInt($(that.ui.input).val()));

		};

		if (force || 13 == e.keyCode) {

			e.preventDefault();

			if (parseInt($(this.ui.input).val()) >= 8) {

				if (parseInt($(this.ui.input).val()) <= 150) {

					submit();

				} else {

					$(this.ui.input).val('150');
					submit();

				}

			} else {

				$(this.ui.input).val('8');
				submit();

			}

			return false;

		} else if (e.keyCode >= 48 && e.keyCode <= 57) {

			return true;

		} else {

			return false;

		}

	},
	fontSizeChange: function (e) {

		var that = this,
			fontSize = $(this.ui.input).val(),
			element = qtee.customDesign.canvas.getElement({ cid: this.model.cid });
		this.state.waitFont = true;

		if (element) {

			var stopTimer = this.$events.triggerHandler('startLoader');
			this.$events.triggerHandler('showProgressState');

			element.setFontSize(fontSize).then(function () {

				stopTimer();
				that.$events.triggerHandler('showSuccessState', 'font size has been set to "' + fontSize);
				that.state.waitFont = false;
				that.state.fontChangedTo = {
					fontSize: fontSize
				};

				if (!that.model.isNew()) {

					that.model.save(element.saveToModel(), {
						success: function (r) {

							that.$events.triggerHandler('add.history', [ [ r ] ]);

						}
					});

				}

			}, stopTimer);

			// set font size of newEl created next to match fontSize
			qtee.customDesign.settings.newEl.text.fontSize = fontSize;

		} else {

			that.state.waitFont = false;

			that.model.set({
				FontSize: fontSize
			});

		}

	},
	initialize: function (opts) {

		opts.backCallback && (this.backCallback = opts.backCallback);
		this.state = {};
		this.$events = $(qtee.customDesign);

	},
	templateHelpers: function templateHelpers () {

		var that = this;
		return {
			initSize: function initSize () {

				return qtee.customDesign.canvas.getElement({ cid: that.model.cid })._fontSize;

			}
		};

	},
	onAttach: function () {

		var that = this;

		// init ui sliders
		$(this.ui.slider).slider();

		$(this.ui.slider).slider('option', {
			min: 8,
			max: 150,
			value: qtee.customDesign.canvas.getElement({ cid: that.model.cid })._fontSize,
			// this gets a live reading of the value and prints it on the page
			slide: function (event, ui) {

				$(that.ui.input).val(ui.value);

			},
			// this updates the value of your hidden field when user stops dragging
			change: function (event, ui) {

				// if it's not programatically change back then update darkroom
				if (event.originalEvent) {

					that.fontSizeChange();

				}

			}
		});

	}
});
